(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-sticky"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('mainNavbar');
      this.headerBounds = {};
      this.currentScrollTop = 110;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('d-none', 'fixed-top');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('d-block', 'fixed-top', 'animate');
      this.header.classList.remove('d-none');
    }

    reset() {
      this.header.classList.remove('d-block', 'fixed-top', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    
var product = JSON.parse(document.getElementById('ProductJson').innerHTML);

/* Updates the displayed prices + writes the selling_plan the cart will use.
   NOTE: only the visible price LABELS were rescoped (.sub-price / .onetime-price)
   so the Subscribe box always shows the sub price and the One-time box always
   shows the one-time price. The cart / checkout logic below is unchanged. */
/* Promotional first-order pricing, from Theme settings > Promotional Offer.
   Set by the inline script above; 0 means no promo, fall back to the plan price. */
var PROMO_FIRST_ORDER_CENTS = window.PROMO_FIRST_ORDER_CENTS || 0;
var PROMO_RENEWAL_NOTE = window.PROMO_RENEWAL_NOTE || '';

function setVariant(sellingPlanId = "") {
  var variantId = Number(document.querySelector('input[name="id"]').value);
  var variant = getCurrentVariant(variantId);

  // Hidden input Shopify uses for the cart
  document.querySelector("input[name=selling_plan]").value = sellingPlanId;

  if (sellingPlanId) {
    // SUBSCRIPTION
    var sellingPlan = (variant.selling_plan_allocations || []).find(function(alloc) {
      return alloc.selling_plan_id == sellingPlanId;
    }) || (variant.selling_plan_allocations || [])[0];

    if (sellingPlan) {
      /* Show the promotional first-order price, matching the Liquid above - otherwise
         changing frequency would replace $49.99 with the raw plan price. */
      var subDisplayCents = (PROMO_FIRST_ORDER_CENTS > 0) ? PROMO_FIRST_ORDER_CENTS : sellingPlan.price;

      document.querySelectorAll('.sub-price').forEach(function(el) {
        el.innerText = Shopify.formatMoney(subDisplayCents);
      });

      if (sellingPlan.compare_at_price) {
        var savings = Math.floor(Math.abs((subDisplayCents - sellingPlan.compare_at_price) / sellingPlan.compare_at_price * 100));
        document.querySelectorAll('.sub-savings').forEach(function(el) { el.innerText = "SAVE " + savings + "%"; });
      }

      /* Keep the renewal note pointing at the real recurring price for this plan. */
      if (PROMO_RENEWAL_NOTE) {
        document.querySelectorAll('.sub-renewal-note').forEach(function(el) {
          el.innerText = PROMO_RENEWAL_NOTE.replace('[renewal]', Shopify.formatMoney(sellingPlan.price));
        });
      }
    }

    document.querySelectorAll('.one-time-message').forEach(el => el.classList.add("d-none"));
    var addonReset = document.querySelector("input[name=addon]");
    if (addonReset) { addonReset.checked = true; }
  } else {
    // ONE-TIME PURCHASE
    var total = variant.price;
    var addonCheck = document.querySelector('input[name="addon"]:checked');
    if (addonCheck && addonCheck.value !== "") {
      total += Number(addonCheck.dataset.price || 0);
    }
    document.querySelectorAll('.onetime-price').forEach(function(el) {
      el.innerText = Shopify.formatMoney(total);
    });
    document.querySelectorAll('.one-time-message').forEach(el => el.classList.remove("d-none"));
  }
}

function getCurrentVariant(variantId) {
  return product.variants.find(function(v) { return v.id == variantId; });
}

/* --- PLAN LISTENERS --- */
var dSub = document.getElementById('desktop_sub');
var dOne = document.getElementById('desktop_onetime');
var dSelect = document.getElementById('desktop_frequency_select');

if (dSub && dOne && dSelect) {
  dSub.addEventListener('change', function() { if(this.checked) setVariant(dSelect.value); });
  dOne.addEventListener('change', function() { if(this.checked) setVariant(""); });
  dSelect.addEventListener('change', function() { if(dSub.checked) setVariant(this.value); });
}

/* --- ADDONS & QUANTITY --- */
document.querySelectorAll('input[name="addon"]').forEach(function(ele) {
  ele.addEventListener("change", function() { setVariant(""); });
});

document.querySelectorAll('#qtySelectDesktop').forEach(function(sel){
  sel.addEventListener("change", function(evt) {
    document.querySelector('[name="quantity"]').value = evt.target.value;
  });
});

/* --- FORM SUBMISSION (unchanged) --- */
document.getElementById('ProductAddToCart').addEventListener("submit", async function(evt) {

evt.preventDefault();

const btn = evt.target.querySelector('button[type="submit"]');
const originalText = btn.innerText;

btn.innerText = "Processing...";
btn.disabled = true;

const addItems = async (items) => {
const r = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items })
});
const text = await r.text();
if (!r.ok) { throw new Error(text); }
return JSON.parse(text);
};

try {

const formData = new FormData(evt.target);
const formProps = Object.fromEntries(formData);

const variantId = Number(formProps['id']);
const quantity = Number(formProps['quantity'] || 1);

const sellingPlanRaw = (formProps['selling_plan'] || "").toString().trim();

const hasSellingPlan = sellingPlanRaw !== "";
const sellingPlanId = hasSellingPlan ? Number(sellingPlanRaw) : null;

const bundleTag = "onetime_trial_bundle";

/* Additive cart: nothing is removed on add. See the matching note in the
   Side Cart / featured-product section - bundles are kept apart by their
   _bundle_supply property, and a repeat add of the same option rolls up
   into one line at a higher quantity. */

/* _bundle_role lets the side cart fold the add-on line into the main product line,
   so the customer sees one price matching the subtotal rather than two component
   prices that look like they do not add up. Underscore = hidden at checkout. */
const checkedAddonEle = document.querySelector('input[name="addon"]:checked');
const supplyLabel = (checkedAddonEle && checkedAddonEle.dataset.supplyLabel) || "";

const itemsToAdd = [{
id: variantId,
quantity: quantity,
selling_plan: sellingPlanId || undefined,
properties: hasSellingPlan ? undefined : {
  _bundle: bundleTag,
  _bundle_role: 'main',
  _bundle_supply: supplyLabel
}
}];

if ( !hasSellingPlan && formProps['addon'] && String(formProps['addon']).length > 1 ) {
const addon = String(formProps['addon']).split(':');
itemsToAdd.push({
id: Number(addon[0]),
quantity: Number(addon[1]),
properties: {
  _bundle: bundleTag,
  _bundle_role: 'addon',
  _bundle_supply: supplyLabel
}
});
}

await addItems(itemsToAdd);

/* Show the side cart instead of navigating away. */
btn.innerText = originalText;
btn.disabled = false;

if (typeof Shopify.reloadSideCart === 'function') {
  await Shopify.reloadSideCart(true);
} else if (typeof Shopify.showCart === 'function') {
  Shopify.showCart(true);
} else {
  window.location.href = "/cart";
}

} catch (e) {
console.error(e);
btn.innerText = originalText;
btn.disabled = false;
}

});

/* --- INITIALIZATION --- */
window.addEventListener('DOMContentLoaded', (event) => {
  var initialId = "";
  var dSubInit = document.getElementById('desktop_sub');
  var dSelectInit = document.getElementById('desktop_frequency_select');

  if (dSubInit && dSubInit.checked && dSelectInit) {
    initialId = dSelectInit.value;
  }
  setVariant(initialId);
});

/* Carousel */
(function () {
  var $mip  = jQuery('#mip-carousel');
  if (!$mip.length) return;

  var $hero = $mip.find('.carousel-hero');
  var $nav  = $mip.find('.carousel-nav');

  var total = $hero.children('div').length;
  if (total <= 1) return;

  var showArrows = $mip.data('slider-arrows') !== false;
  var hasNav     = $nav.length > 0;

  // Main image: one at a time, no loop, swipeable
  $hero.not('.slick-initialized').slick({
    slidesToShow: 1, slidesToScroll: 1, arrows: false, infinite: false, lazyLoad: 'ondemand'
  });

  if (!hasNav) return;

  // Thumbnail strip: shows up to 7, no built-in arrows, not draggable (we drive it)
  $nav.not('.slick-initialized').slick({
    slidesToShow: 1, slidesToScroll: 1, variableWidth: true,
    arrows: false, infinite: false, focusOnSelect: false,
    swipe: false, draggable: false, touchMove: false
  });

  var active = 0, navStart = 0, $prev = null, $next = null;

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(v, hi)); }

  // Mirror the slick responsive config so our scroll math matches what's visible
  var THUMB_W = 76; // fixed slide width: 60px image + 4px gutter each side, was 68
  function perView() {
    var listW = $nav.find('.slick-list').width() || 0;
    return Math.max(1, Math.floor(listW / THUMB_W));
  }

  function highlight() {
    $nav.find('.slick-slide').removeClass('is-active');
    $nav.find('.slick-slide[data-slick-index="' + active + '"]').addClass('is-active');
  }

  function updateArrows() {
    if ($prev) $prev.toggleClass('slick-disabled', active <= 0);
    if ($next) $next.toggleClass('slick-disabled', active >= total - 1);
  }

  // Runs after the main image changes (arrows, thumb click, or swipe all route here)
  function syncToHero() {
    active = $hero.slick('slickCurrentSlide');

    var show = perView();
    var maxStart = Math.max(0, total - show);
    if (active < navStart)                  navStart = active;
    else if (active > navStart + show - 1)  navStart = active - show + 1;
    navStart = clamp(navStart, 0, maxStart);

    if (total <= show) {
      // fewer thumbnails than the visible window: center them, no scrolling needed
      $nav.addClass('is-centered');
      $nav.find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
    } else {
      $nav.removeClass('is-centered');
      $nav.find('.slick-track').css('transform', 'translate3d(' + (-navStart * THUMB_W) + 'px, 0px, 0px)');
    }

    highlight();
    updateArrows();
  }

  $hero.on('afterChange', syncToHero);

  // Click a thumbnail -> select that image
  $nav.on('click', '.slick-slide', function () {
    var idx = parseInt(jQuery(this).attr('data-slick-index'), 10);
    if (!isNaN(idx)) $hero.slick('slickGoTo', idx);
  });

  // Arrows step the SELECTED image
  if (showArrows) {
    $prev = jQuery(`
      <button type="button" class="slick-prev mip-nav-arrow" aria-label="Previous"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 13L1 7L7 1" stroke="#CC9751" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </button>`);
    $next = jQuery(`
      <button type="button" class="slick-next mip-nav-arrow" aria-label="Next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 13L7 7L1 1" stroke="#CC9751" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </button>`);
    $nav.append($prev, $next);
    $prev.on('click', function () { $hero.slick('slickGoTo', active - 1); });
    $next.on('click', function () { $hero.slick('slickGoTo', active + 1); });
  }

  // Re-align the window when the breakpoint changes
  var rt;
  jQuery(window).on('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(syncToHero, 150);
  });

  // Re-measure once everything (grid width, lazy-loaded thumbs) has settled,
  // so slick's track width matches slideWidth × slideCount.
  jQuery(window).on('load', function () {
    $hero.slick('setPosition');
    $nav.slick('setPosition');
    syncToHero();
  });  

  syncToHero(); // initial paint: image 1 active, strip showing the first 7
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendations);

      const url = productRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
		MiniCart.bindUIActions();
      })
      .catch(e => {
        console.error(e);
      });

    };

    const productRecommendations = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();
})();
